import React from 'react';
import type { Icon } from '@phosphor-icons/react';

/** Innere Karte in Panels (README §4.3: --fill mit Linie, Radius 20–26). */
export function InnenKarte({ children, radius = 24, padding = 18, gap = 12, style, className = '' }: {
  children: React.ReactNode; radius?: number; padding?: number | string; gap?: number; style?: React.CSSProperties; className?: string;
}) {
  return (
    <div className={`immo-innen flex flex-col min-w-0 ${className}`} style={{ borderRadius: radius, padding, gap, ...style }}>
      {children}
    </div>
  );
}

/** Kartentitel 15/800, optional Icon und Zusatz rechts. */
export function KartenTitel({ children, icon: IconKomp, rechts }: { children: React.ReactNode; icon?: Icon; rechts?: React.ReactNode }) {
  return (
    <div className="flex items-center justify-between flex-wrap" style={{ gap: 10 }}>
      <span className="flex items-center" style={{ gap: 8, fontSize: 15, fontWeight: 800 }}>
        {IconKomp && <IconKomp weight="fill" size={18} color="var(--acc)" />}
        {children}
      </span>
      {rechts !== undefined && <span style={{ fontSize: 12, color: 'var(--ink3)' }}>{rechts}</span>}
    </div>
  );
}

/** Leerer Zustand in Panels. */
export function LeerZustand({ icon: IconKomp, titel, text, children }: { icon: Icon; titel: string; text?: string; children?: React.ReactNode }) {
  return (
    <div className="immo-innen flex flex-col items-center text-center" style={{ borderRadius: 24, padding: '36px 20px', gap: 8 }}>
      <IconKomp weight="duotone" size={34} color="var(--ink3)" />
      <span style={{ fontSize: 15, fontWeight: 800 }}>{titel}</span>
      {text && <span style={{ fontSize: 13, color: 'var(--ink3)', maxWidth: 420 }}>{text}</span>}
      {children}
    </div>
  );
}
